"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _WarningRound = _interopRequireDefault(require("@rsuite/icon-font/lib/status/WarningRound"));

// Generated by script, don't edit it please.
var WarningRound = (0, _createSvgIcon["default"])({
  as: _WarningRound["default"],
  ariaLabel: 'warning round',
  category: 'status',
  displayName: 'WarningRound'
});
var _default = WarningRound;
exports["default"] = _default;
module.exports = exports.default;